import { FC } from 'react';

import type { TextAreaInputProps } from '@types';

import { BaseTextAreaInput, ImportTextAreaInput, StringArrayTextAreaInput } from '.';

export const TextAreaInput: FC<TextAreaInputProps> = ({ isStringArray = false, uploadLabel, ...props }) => {
  if (isStringArray) return <StringArrayTextAreaInput {...props} />;

  return uploadLabel ? <ImportTextAreaInput uploadLabel={uploadLabel} {...props} /> : <BaseTextAreaInput {...props} />;
};
